import styled, { css } from 'styled-components';
import { btnReset, mq } from '../../../stylesheets/tools';

const StyledNavButton = styled.button`
  ${btnReset()};

  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  svg {
    fill: #000;
    height: 28px;
    width: 28px;
    
    ${mq('s')} {
      height: 35px;
      width: 35px;
    }
  }

  ${props =>
    props.inverted &&
    css`
      svg {
        fill: #fff;
      }
    `}

    ${props =>
      props.currentLevel === 2 &&
      css`
        svg {
          fill: #000;

          ${mq('l')} {
            fill: #fff;
          }
        }
      `}

  ${props =>
    props.close &&
    props.inverted &&
    css`
      svg {
        fill: ${props.theme.globalTheme.primary};
      }
    `}
`;

export default StyledNavButton;
